import Service, { service } from '@ember/service';

export default class ClinicianSearchService extends Service {
  @service store;
  @service router;
  @service currentPractice;
  @service session;

  @service('clinician-search/facet-names') facetNames;
  @service('clinician-search/preselection') preselection;
  @service('clinician-search/preselection-navigation') preselectionNavigation;
  @service('clinician-search/query') query;
  @service('clinician-search/send-all') sendAll;
  @service('clinician-search/next-slots') nextSlots;
  @service('clinician-search/clinician-details') clinicianDetails;
  @service('clinician-search/mobile') mobile;

  constructor() {
    super(...arguments);
    this.nextSlots.setOnBatchComplete(ids => this.clinicianDetails.enrich(ids));
  }

  resetState() {
    this.mobile.resetState();
    this.query.resetState();
    this.sendAll.resetState();
    this.nextSlots.resetState();
    this.clinicianDetails.resetState();
    this.preselection.resetState();
    this.preselectionNavigation.resetState();
  }

  get isClinicianSearchRoute() {
    let currentRouteName = this.router.currentRouteName;
    return Boolean(currentRouteName && currentRouteName.endsWith('.clinician-search'));
  }

  get isEnabled() {
    let isLoggedIn = !!this.session.currentClient;
    let { featureGroupPracticeClinicianFiltering, isGroupPractice } =
      this.currentPractice.getProperties(
        'featureGroupPracticeClinicianFiltering',
        'isGroupPractice'
      );
    return Boolean(featureGroupPracticeClinicianFiltering && isGroupPractice && !isLoggedIn);
  }
}
